import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getCities = async () => {
    const { data, error } = await supabase
        .from('cities')
        .select(`*`)

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetCities() {
    return useQuery({
        queryKey: ['useGetCities'],
        queryFn: () => getCities(),
        staleTime: 0,
    })
}
